import { debounce } from 'lodash';
import { execOnLoad } from '@general/helpers';
import './search-bar.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initSearchBar = (context) => {
  const baseClass = 'search-bar__container';
  const staticClass = `${baseClass}--static`;
  const snippetContainer = context.classList.contains(baseClass)
    ? context
    : context.closest(`.${baseClass}`);
  if (!snippetContainer) return;

  const form = snippetContainer.querySelector('.search-bar__form');
  if (!form) return;

  const productsResultsWrapper = snippetContainer.querySelector(
    '.search-bar__products',
  );
  const suggestionsResultsWrapper = snippetContainer.querySelector(
    '.search-bar__suggestions',
  );
  const mainInput = snippetContainer.querySelector('input[name="q"]');

  const appendProducts = (data) => {
    if (!productsResultsWrapper) return;
    if (!data) {
      productsResultsWrapper.innerHTML = '';
    } else {
      productsResultsWrapper.innerHTML = new DOMParser()
        .parseFromString(data, 'text/html')
        .querySelector('.shopify-section').innerHTML;
      if (typeof window?.dAgency?.initProductTile !== 'undefined')
        productsResultsWrapper
          .querySelectorAll('.product-tile__container')
          .forEach((tile) => window.dAgency.initProductTile(tile));
      if (typeof window?.dAgency?.initFitSize === 'function')
        productsResultsWrapper
          .querySelectorAll('.fit-size__container')
          .forEach((fitSizeWrapper) =>
            window.dAgency.initFitSize(fitSizeWrapper),
          );
    }
  };

  const appendSuggestions = (data) => {
    if (!suggestionsResultsWrapper) return;
    suggestionsResultsWrapper
      .querySelectorAll('.chip')
      .forEach((chip) => chip.remove());
    if (data?.resources?.results?.queries?.length > 0) {
      data.resources.results.queries.forEach(({ url, text }) => {
        const link = document.createElement('a');
        link.href = url;
        link.classList.add('chip');
        link.classList.add('chip--primary');
        link.classList.add('chip--s');
        link.innerText = text;
        const qArg = url
          .split('?')
          .reverse()[0]
          .split('&')
          .find((arg) => /^q=/.test(arg));
        if (qArg) {
          const qValue = qArg.split('=')[1];
          link.addEventListener('click', (e) => {
            e.preventDefault();
            mainInput.value = qValue.replaceAll('+', ' ');
            fetchSuggestions();
          });
        }
        suggestionsResultsWrapper.appendChild(link);
      });
    }
  };

  const clearBtn = snippetContainer.querySelector('.search-bar__clear');
  if (clearBtn && mainInput)
    clearBtn.addEventListener('click', () => {
      mainInput.value = '';
      fetchSuggestions();
    });

  const fetchSuggestions = debounce(() => {
    if (snippetContainer.classList.contains(staticClass)) return;
    const params = new URLSearchParams(new FormData(form));
    if (!params.get('q')) {
      appendSuggestions();
      appendProducts();
      return;
    }
    form.classList.add('loading');

    fetch(
      `${window.Shopify.routes.root}search/suggest?section_id=predictive-results&${params.toString()}`,
    )
      .then((res) => res.text())
      .then((data) => {
        appendProducts(data);
      })
      .catch((err) => {
        console.error(err);
      });
    fetch(
      `${window.Shopify.routes.root}search/suggest.json?${params.toString()}`,
    )
      .then((res) => res.json())
      .then((data) => {
        appendSuggestions(data);
      })
      .catch((err) => {
        console.error(err);
      });

    form.classList.remove('loading');
  }, 500);

  form.addEventListener('input', () => {
    fetchSuggestions();
  });
};

execOnLoad(window.dAgency.initSearchBar, '.search-bar__container');
